import { createContext, useContext, useMemo, useRef } from 'react';

interface NodeTextScaleContextType {
  nodesTextScaleRef: React.MutableRefObject<Map<string, number>>;
  isInitialized: boolean;
}

const NodeTextScaleContext = createContext<NodeTextScaleContextType>({
  nodesTextScaleRef: { current: new Map<string, number>() },
  isInitialized: false,
});

export const NodeTextScaleProvider = ({ children }: { children: React.ReactNode }) => {
  const nodesTextScaleRef = useRef<Map<string, number>>(new Map<string, number>());
  return (
    <NodeTextScaleContext.Provider
      value={useMemo(() => ({ nodesTextScaleRef, isInitialized: true }), [nodesTextScaleRef])}
    >
      {children}
    </NodeTextScaleContext.Provider>
  );
};

export const useNodeTextScaleCtx = () => {
  const context = useContext(NodeTextScaleContext);
  if (!context || !context.isInitialized) {
    throw new Error('useNodeTextScaleCtx must be used within a NodeTextScaleProvider');
  }
  return useMemo(
    () => ({ nodesTextScaleRef: context.nodesTextScaleRef }),
    [context.nodesTextScaleRef],
  );
};
